import { collection, doc } from 'firebase/firestore';
import { firestore } from 'src/lib/firebase';

const generatePlayId = () =>
  generateFirestoreKey(collection(firestore, 'plays'));

const generateFirestoreKey = (collectionRef) => doc(collectionRef).id;

export { generatePlayId, generateFirestoreKey };
